<template>

  <div
    class="modalo adapted-meet-max-width"
    v-if="alertModal">

    <div 
      class="modalo-backgroud adapted-meet-max-width"
      @click="closeModal()"></div>

    <div class="modalo-main">

      <div class="modalo-container">
        
        <div class="card">
          <div
            class="card-header"
            :class="`bg-${style}`">
            <button
              class="btn btn-sm bt-close"
              :class="`btn-${style}`"
              @click="closeModal">
              <i class="fas fa-times" />
            </button>
            <h4>{{ title }}</h4>
          </div>
          <div class="card-body">
            <div
              class="message mb-4"
              v-if="message"
              v-html="message">
            </div>
            <div v-if="type === 'yes-no'">
              <button
                class="btn btn-lg"
                :class="`btn-${style}`"
                @click="accept">{{ $t('Yes') }}</button>
              <button
                class="btn btn-lg btn-secondary"
                @click="closeModal">{{ $t('No') }}</button>
            </div>
            <div v-if="type === 'ok'">
              <button
                class="btn btn-lg btn-secondary"
                @click="accept">{{ $t('Ok') }}</button>
            </div>
          </div>
        </div>

      </div>
      <!--end modalo-container-->

    </div>
    <!--end modalo-main-->

  </div>

</template>

<script>
export default {
  name: 'AlertModal',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    alertModal () {
      return this.$store.getters.getAlertModal
    },
    type () {
      return this.alertModal.type || 'yes-no'
    },
    title () {
      return this.alertModal.title || 'Deseja realmente remover esse registro?'
    },
    message () {
      return this.alertModal.message === undefined ? 'Essa operação não poderá ser desfeita.' : this.alertModal.message
    },
    style () {
      return this.alertModal.style || 'danger'
    }
  },
  created () {
  },
  methods: {
    /*
    closeModal
    */
    closeModal () {
      this.$store.dispatch('closeAlertModal')
    },
    /*
    accept
    */
    accept () {
      if (this.alertModal.action) {
        this.alertModal.action()
      }
      this.closeModal()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalo{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  padding: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
}
  .modalo-backgroud{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .modalo-main{
    width: 100%;
    max-width: 400px;
    position: relative;
    z-index: 2;
  }
  .modalo-main .card{
    border: 0;
  }
  .modalo-main .card > .card-header {
    color: #ffffff;
  }
  .modalo-main .card > .card-header .bt-close {
    float: right;
    margin: 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/AlertModal.vue